// src/services/farmerVisit.service.js
import api from './api';

const farmerVisitService = {

  // ── Search farmers by name/mobile (used in Start KM) ──────────────────────
  searchFarmers: async (query) => {
    try {
      const response = await api.get('/farmer-visits/search', {
        params: { q: query },
      });
      return response.data;
    } catch (error) {
      console.error('Error searching farmers:', error);
      throw error;
    }
  },

  // ── Get villages list (First Visit) ───────────────────────────────────────
  getVillages: async (search = '') => {
    try {
      const params = {};
      if (search) params.search = search;
      const response = await api.get('/farmer-visits/villages', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching villages:', error);
      throw error;
    }
  },

  // ── Get farmers in a village ───────────────────────────────────────────────
  getFarmersByVillage: async (village, search = '') => {
    try {
      const params = {};
      if (search) params.search = search;
      const encodedVillage = encodeURIComponent(village);
      const response = await api.get(
        `/farmer-visits/villages/${encodedVillage}/farmers`,
        { params }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching farmers:', error);
      throw error;
    }
  },

  // ── Flat followup list (hierarchy-aware) ──────────────────────────────────
  getFollowupList: async (search = '') => {
    try {
      const params = {};
      if (search) params.search = search;
      const response = await api.get('/farmer-visits/followup', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching followup list:', error);
      throw error;
    }
  },

  // ── Get last visit for a farmer ───────────────────────────────────────────
  getLastVisit: async (farmerId) => {
    try {
      const response = await api.get(`/farmer-visits/farmers/${farmerId}/last-visit`);
      return response.data;
    } catch (error) {
      console.error('Error fetching last visit:', error);
      throw error;
    }
  },

  // ── Get traveling with employees ──────────────────────────────────────────
  getTravelingWithEmployees: async () => {
    try {
      const response = await api.get('/farmer-visits/traveling-with');
      return response.data;
    } catch (error) {
      console.error('Error fetching employees:', error);
      throw error;
    }
  },

  // ── Create single visit (first or followup) ───────────────────────────────
  createVisit: async (data) => {
    try {
      const response = await api.post('/farmer-visits', data);
      return response.data;
    } catch (error) {
      console.error('Error creating farmer visit:', error);
      throw error;
    }
  },

  // ── Create multiple visits at once (from Start KM — no 1000m check) ─────────
  createBulkVisits: async (visits) => {
    try {
      const response = await api.post('/farmer-visits/bulk', { visits });
      return response.data;
    } catch (error) {
      console.error('Error creating bulk visits:', error);
      throw error;
    }
  },

  // ── Get today's visits ────────────────────────────────────────────────────
  getTodayVisits: async () => {
    try {
      const response = await api.get('/farmer-visits/today');
      return response.data;
    } catch (error) {
      console.error('Error fetching today visits:', error);
      throw error;
    }
  },

  // ── Get visits for statement view (senior roles) ──────────────────────────
  getVisitsForStatement: async (userId) => {
    try {
      const response = await api.get(`/farmer-visits/statements/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching visits for statement:', error);
      throw error;
    }
  },

  getVisitsForFarmer: async (farmerId) => {
  const response = await api.get(`/farmer-visits/farmers/${farmerId}/history`);
  return response.data;
},
getMyRecentActivity: async (limit = 10) => {
  const response = await api.get(`/farmer-visits/my-activity?limit=${limit}`);
  return response.data;
},

};

export default farmerVisitService;